import React, { useContext, useEffect, useState } from "react";
import styles from "../../../form.module.css";
import {
  Button,
  Col,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Typography,
} from "antd";
import useFetch from "../../../../../hooks/useFetch";
import useToast from "../../../../../hooks/useToast";
import {
  eDocType,
  eFORMSTATUS,
  eResultCode,
  eYES_OR_NO,
  INPUT_LENGTH,
} from "../../../../../utils/enum";
import { ToastOpen, ToastType } from "../../../../../state/toast/slice";
import {
  CloseOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import Text, { LanguageContext } from "../../../../../context/language-context";
import { FaCheck } from "react-icons/fa";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserContext } from "../../../../../context";
import {
  GetFormData,
  updateField,
  UploadDocs,
} from "../../../../../utils/api.constant";
import AuthUtil from "../../../../../utils/auth";
import { TFormProps } from "../../../../../types";
import { LoaderContext } from "../../../../../context/loader";
import EncryptUtils from "../../../../../utils/encrypt";
import Utils from "../../../../../utils";
import {
  allowOnlyNumericInput_onKeyDown,
  disableFutureDates_on_input_date_max,
  disableFutureDates_on_input_month_max,
  numberInputRules,
  validateFile,
} from "../../../../../utils/input.validator";

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StudentPartTwo = ({
  disabled,
  currentFormId,
  currentUfmId,
}: TFormProps) => {
  const [form] = Form.useForm();
  const contextForLoader = useContext(LoaderContext);
  const { isLoading, setIsLoading } = contextForLoader as any;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { post } = useFetch();
  const { onShowToast } = useToast();
  const navigate = useNavigate();
  const [formId, setFormId] = useState<string | null>(null);
  const [ufmId, setUfmId] = useState<string | null>(null);
  const [formFor, setFormFor] = useState<string | null>(null);
  const { user } = useContext(UserContext);
  const [documentsData, setDocumentsData] = useState<any>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [attachmentId, setAttachmentId] = useState<string | null>(null);
  const [signatureId, setSignatureId] = useState<string | null>(null);
  const [applicantAffidavit, setApplicantAffidavit] = useState<string | null>(
    null
  );

  const [PT2_Q17_DOC, setPT2_Q17_DOC] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState<Boolean>(false);

  const [applyPdfStyles, setApplyPdfStyles] = useState(false);

  const uploadButton = (
    <button
      style={{ border: 0, background: "none" }}
      type='button'
    >
      {isLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const STUDENT_PT2_Q4_A = Text({ tid: "STUDENT_PT2_Q4_A", def: " " });
  const STUDENT_PT2_Q4_B = Text({ tid: "STUDENT_PT2_Q4_B", def: " " });
  const STUDENT_PT2_Q4_C = Text({ tid: "STUDENT_PT2_Q4_C", def: " " });
  const STUDENT_PT2_Q4_D = Text({ tid: "STUDENT_PT2_Q4_D", def: " " });
  const STUDENT_PT2_Q4_E = Text({ tid: "STUDENT_PT2_Q4_E", def: " " });

  const STUDENT_PT2_Q6_B = Text({ tid: "STUDENT_PT2_Q6_B", def: " " });
  const STUDENT_PT2_Q6_C = Text({ tid: "STUDENT_PT2_Q6_C", def: " " });
  const STUDENT_PT2_Q6_D = Text({ tid: "STUDENT_PT2_Q6_D", def: " " });
  const STUDENT_PT2_Q6_E = Text({ tid: "STUDENT_PT2_Q6_E", def: " " });
  const STUDENT_PT2_Q6_F = Text({ tid: "STUDENT_PT2_Q6_F", def: " " });
  const STUDENT_PT2_Q6_G = Text({ tid: "STUDENT_PT2_Q6_G", def: " " });

  const STUDENT_PT2_Q7_A = Text({ tid: "STUDENT_PT2_Q7_A", def: " " });
  const STUDENT_PT2_Q7_B = Text({ tid: "STUDENT_PT2_Q7_B", def: " " });
  const STUDENT_PT2_Q7_C = Text({ tid: "STUDENT_PT2_Q7_C", def: " " });
  const STUDENT_PT2_Q7_D = Text({ tid: "STUDENT_PT2_Q7_D", def: " " });

  const STUDENT_PT2_Q8_A = Text({ tid: "STUDENT_PT2_Q8_A", def: " " });
  const STUDENT_PT2_Q8_B = Text({ tid: "STUDENT_PT2_Q8_B", def: " " });
  const STUDENT_PT2_Q8_C = Text({ tid: "STUDENT_PT2_Q8_C", def: " " });
  const STUDENT_PT2_Q8_D = Text({ tid: "STUDENT_PT2_Q8_D", def: " " });

  const STUDENT_PT2_Q9_A = Text({ tid: "STUDENT_PT2_Q9_A", def: " " });
  const STUDENT_PT2_Q9_B = Text({ tid: "STUDENT_PT2_Q9_B", def: " " });
  const STUDENT_PT2_Q9_C = Text({ tid: "STUDENT_PT2_Q9_C", def: " " });
  const STUDENT_PT2_Q9_D = Text({ tid: "STUDENT_PT2_Q9_D", def: " " });

  const STUDENT_PT2_Q10_A = Text({ tid: "STUDENT_PT2_Q10_A", def: " " });
  const STUDENT_PT2_Q10_B = Text({ tid: "STUDENT_PT2_Q10_B", def: " " });
  const STUDENT_PT2_Q10_C = Text({ tid: "STUDENT_PT2_Q10_C", def: " " });
  const STUDENT_PT2_Q10_D = Text({ tid: "STUDENT_PT2_Q10_D", def: " " });

  const STUDENT_PT2_Q16 = Text({ tid: "STUDENT_PT2_Q16", def: " " });
  const STUDENT_PT2_Q17 = Text({ tid: "STUDENT_PT2_Q17", def: " " });
  const STUDENT_PT2_Q17_A = Text({ tid: "STUDENT_PT2_Q17_A", def: " " });
  const STUDENT_PT2_Q18 = Text({ tid: "STUDENT_PT2_Q18", def: " " });
  const STUDENT_PT2_Q19 = Text({ tid: "STUDENT_PT2_Q19", def: " " });
  const STUDENT_PT2_Q19_A = Text({ tid: "STUDENT_PT2_Q19_A", def: " " });
  const STUDENT_PT2_Q19_B = Text({ tid: "STUDENT_PT2_Q19_B", def: " " });
  const STUDENT_PT2_Q19_C = Text({ tid: "STUDENT_PT2_Q19_C", def: " " });
  const STUDENT_PT2_Q19_D = Text({ tid: "STUDENT_PT2_Q19_D", def: " " });
  const ATTACHED_DOC =
    Text({
      tid: "ATTACHED_DOCUMENT",
      def: "Attached Document",
    }) + ":";

  const REQUIRED = Text({ tid: "REQUIRED", def: "Required" });
  const YES = Text({ tid: "YES", def: "Yes" });
  const NO = Text({ tid: "NO", def: "No" });
  const DESC = Text({ tid: "DESC", def: " " });
  const PREVIEW = Text({ tid: "PREVIEW", def: "Preview" });

  const REMOVE = Text({ tid: "REMOVE", def: " " });
  const ADD = Text({ tid: "ADD", def: " " });

  useEffect(() => {
    const fieldsToInitialize = [
      "STUDENT_PT2_Q4",
      "STUDENT_PT2_Q6",
      "STUDENT_PT2_Q7",
      "STUDENT_PT2_Q8",
      "STUDENT_PT2_Q9",
      "STUDENT_PT2_Q10",
      "STUDENT_PT2_Q19",
    ];

    fieldsToInitialize.forEach((field) => {
      if (
        !form.getFieldValue(field) ||
        form.getFieldValue(field).length === 0
      ) {
        form.setFieldsValue({ [field]: [{}] });
      }
    });
  }, []);

  useEffect(() => {
    if (searchParams) {
      const formId = EncryptUtils.decrypt(searchParams.get("id2") || "");
      const ufmId = EncryptUtils.decrypt(searchParams.get("ufmid") || "");
      const formFor = EncryptUtils.decrypt(searchParams.get("ff") || "");
      setFormId(formId);
      setUfmId(ufmId);
      setFormFor(formFor);
    }
    if (currentFormId && currentUfmId) {
      setFormId(EncryptUtils.decrypt(currentFormId));
      setUfmId(EncryptUtils.decrypt(currentUfmId));
    }
  }, [searchParams, currentFormId, currentUfmId]);

  // Helper function to properly serialize table data with file fields cleared
  const serializeTableData = (
    tableData: any[],
    fileFieldsToRemove: string[] = []
  ) => {
    return JSON.stringify(
      tableData.map((item: any) => {
        const serializedItem = { ...item };

        // Always clear file input fields to prevent file path issues
        fileFieldsToRemove.forEach((fieldName) => {
          if (serializedItem[fieldName]) {
            serializedItem[fieldName] = "";
          }
        });

        // Specifically handle known file fields for student form
        const knownFileFields = [
          "STUDENT_PT2_Q6_F",
          "STUDENT_PT2_Q9_D",
          "STUDENT_PT2_Q8_D",
        ];
        knownFileFields.forEach((fieldName) => {
          if (serializedItem[fieldName]) {
            serializedItem[fieldName] = "";
          }
        });

        return serializedItem;
      })
    );
  };

  const handleFieldChange = async (
    field: string,
    value: any,
    bulkPayload?: any,
    isSubmitted?: boolean
  ) => {
    if (formId?.length && ufmId?.length) {
      try {
        setIsSubmitting(true);
        const payload: any = {
          data: {
            id: formId,
            userFormMappingId: ufmId,
          },
        };
        if (field.length > 0) {
          const trimmedValue = value.trim();
          if (trimmedValue.length) {
            payload.data[field] = trimmedValue || "";
          } else {
            form.setFieldValue(field, "");
            return;
          }
        }
        if (bulkPayload) {
          payload.data = {
            ...payload.data,
            ...bulkPayload,
          };
        }
        if (isSubmitted) {
          payload.data.isSubmitted = true;
        }
        const response = await post(updateField, payload);
        const { dataResponse } = response;
        const { returnCode, description } = dataResponse;
        if (returnCode == eResultCode.SUCCESS) {
          if (isSubmitted) {
            onShowToast({
              type: ToastType.success,
              title: <FaCheck />,
              position: ToastOpen.leftBottom,
              content: "Form Submitted Successfully!",
            });
            setTimeout(() => {
              navigate("/");
            }, 1000);
          }
        } else if (returnCode == eResultCode.INVALID_REQUEST) {
          onShowToast({
            type: ToastType.error,
            title: <ExclamationCircleOutlined />,
            position: ToastOpen.leftBottom,
            content: description,
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const uploadDocument = async (
    file: File,
    type: eDocType,
    documentName?: string
  ) => {
    try {
      setIsUploading(true);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("docType", type.toString());
      formData.append("ufmId", ufmId || "");
      formData.append("userId", user?.id?.toString() || "");
      formData.append("labelName", documentName || "");
      formData.append("currentStage", eFORMSTATUS.STAGE2INPROGRESS.toString());
      const response = await fetch(
        `${process.env.REACT_APP_PUBLIC_API_BASEURL}${UploadDocs}`,
        {
          method: "POST",
          body: formData,
          headers: { ...AuthUtil.getToken() },
        }
      );
      const res = await response.json();
      const { data, dataResponse } = res;
      const { returnCode, description } = dataResponse;

      if (returnCode == eResultCode.SUCCESS) {
        setIsUploading(false);

        switch (documentName) {
          case "STUDENT_PT2_Q22":
            setSignatureId(data.docUrl.toString());
            break;
          case "STUDENT_PT2_Q26":
            setApplicantAffidavit(data.docUrl.toString());
            break;
          case "STUDENT_PT2_Q17":
            setPT2_Q17_DOC(data.docUrl.toString());
            break;
          case "STUDENT_PT2_Q5":
            setAttachmentId(data.docUrl.toString());
            break;
          default:
            break;
        }
        return data.docUrl.toString();
      } else {
        setIsUploading(false);
        console.error("Failed to upload images", response.statusText);
      }
    } catch (error) {
      setIsUploading(false);
      console.error(error);
    }
  };

  const getFormData = async () => {
    setIsLoading(true);
    try {
      const payload: any = {
        data: {
          id: formId,
          userFormMappingId: ufmId,
          isPtOne: false,
          year: 2025
        },
      };

      const response = await post(GetFormData, payload);
      const { dataResponse, data } = response;
      const { returnCode, description } = dataResponse;
      if (returnCode == eResultCode.SUCCESS) {
        const formData = Object.values(data?.studentPt2Forms || {}).every(
          (value) => value === null
        )
          ? {}
          : data?.studentPt2Forms || {};

        // List of fields to exclude (file input fields)
        const jsonStringFields = [
          "STUDENT_PT2_Q4",
          "STUDENT_PT2_Q6",
          "STUDENT_PT2_Q7",
          "STUDENT_PT2_Q8",
          "STUDENT_PT2_Q9",
          "STUDENT_PT2_Q10",
          "STUDENT_PT2_Q19",
        ];

        const fileFields = [
          "STUDENT_PT2_Q5",

          "STUDENT_PT2_Q17",
          "STUDENT_PT2_Q22",
          "STUDENT_PT2_Q26",
        ];

        const formattedData = Object.keys(formData).reduce(
          (acc: { [key: string]: any }, key) => {
            if (jsonStringFields.includes(key)) {
              try {
                const parsedArr = formData[key]
                  ? JSON.parse(formData[key])
                  : [{}];
                if (Array.isArray(parsedArr)) {
                  parsedArr.forEach((item: any, index: number) => {
                    if (item.STUDENT_PT2_Q9_D) {
                      item.STUDENT_PT2_Q9_D = "";
                    }
                    if (item.STUDENT_PT2_Q8_D) {
                      item.STUDENT_PT2_Q8_D = "";
                    }
                    if (item.STUDENT_PT2_Q6_F) {
                      item.STUDENT_PT2_Q6_F = "";
                    }
                  });
                }
                acc[key] = parsedArr;
              } catch (error) {
                console.error(error);
              }
            } else if (fileFields.includes(key)) {
              acc[key] = "";
            } else {
              acc[key] = formData[key];
            }
            return acc;
          },
          {}
        );

        if (formattedData) {
          form.setFieldsValue(formattedData);
        }

        setDocumentsData(data?.documents);

        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (formId?.length && ufmId?.length) {
      getFormData();
    }
  }, [formId, ufmId]);

  useEffect(() => {
    const documentFields = [
      { id: attachmentId, field: "STUDENT_PT2_Q5" },
      { id: signatureId, field: "STUDENT_PT2_Q22" },
      { id: applicantAffidavit, field: "STUDENT_PT2_Q26" },
      { id: PT2_Q17_DOC, field: "STUDENT_PT2_Q17" },
    ];

    documentFields.forEach(({ id, field }) => {
      if (id) {
        handleFieldChange(field, id);
      }
    });
  }, [attachmentId, signatureId, PT2_Q17_DOC]);
  const handleFileUpload = async (
    e: React.ChangeEvent<HTMLInputElement>,
    form: any,
    index: number,
    name: string,
    fieldName: string,
    fileFieldName: string,
    handleFieldChange: (field: string, value: any) => void,
    uploadDocument: (
      file: File,
      type: eDocType,
      documentName?: string
    ) => Promise<string>
  ) => {
    if (e.target.files && e.target.files[0]) {
      const docId = await uploadDocument(
        e.target.files[0],
        eDocType.OTHER,
        `${fieldName}_${index + 1}`
      );

      form.setFieldValue(
        [fieldName, parseInt(name), `${fieldName}_DOC`],
        docId
      );

      const updatedJson = JSON.parse(
        JSON.stringify(form.getFieldValue(fieldName))
      ).map((item: any) => ({
        ...item,
        [fileFieldName]: "",
      }));

      // form.setFieldValue(fieldName, updatedJson);

      handleFieldChange(
        fieldName,
        serializeTableData(updatedJson, [fileFieldName])
      );
    }
  };

  const LengthCounter: React.FC<{
    form: any;
    fieldName: string | string[];
  }> = ({ form, fieldName }) => {
    // Use useWatch to get real-time updates for the field value
    const fieldValue = Form.useWatch(fieldName, form);

    return (
      <div className='length_counter'>
        {(fieldValue || "").length}/{INPUT_LENGTH.TEXTAREA_LENGTH}
      </div>
    );
  };

  const handleGeneratePDF = (id: string, fileName: string) => {
    setApplyPdfStyles(true);
    setTimeout(() => {
      Utils.generatePDF(id, fileName);
      setApplyPdfStyles(false);
    }, 0);
  };

  return (
    <div
      id='studentFormPart2'
      className={`${styles.formWrapper} studentPartTwo studentTeacherSchoolFormWrapper`}
    >
      <Form
        {...formItemLayout}
        form={form}
        name='register'
        onFinish={() => handleFieldChange("", "", null, true)}
        initialValues={{}}
        scrollToFirstError
        layout='vertical'
      >
        <Row>
          <Flex
            gap='middle'
            align='start'
            justify='space-between'
            style={{ width: "100%" }}
          >
            <Col>
              <Typography.Title level={3}>
                {Text({
                  tid: "STUDENT_PART_2_FORM_HEADING",
                  def: "STUDENT_PART_2_FORM_HEADING",
                })}
              </Typography.Title>
              {!disabled && (
                <Typography.Text type='danger'>
                  {Text({
                    tid: "all_fields_are_mandatory",
                    def: "All fields are mandatory!",
                  })}
                </Typography.Text>
              )}
            </Col>
          </Flex>
        </Row>
        <Row>
          {/* 1. Name */}
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT2_Q1'
              label={Text({
                tid: "STUDENT_PT2_Q1",
                def: "Name",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) => {
                  handleFieldChange("STUDENT_PT2_Q1", e.target.value);
                  handleFieldChange("STUDENT_PT2_Q11", e.target.value);
                  handleFieldChange("STUDENT_PT2_Q12", e.target.value);
                  form.setFieldValue("STUDENT_PT2_Q11", e.target.value);
                  form.setFieldValue("STUDENT_PT2_Q12", e.target.value);
                }}
                onChange={(e) => {
                  form.setFieldValue("STUDENT_PT2_Q11", e.target.value);
                  form.setFieldValue("STUDENT_PT2_Q12", e.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {/* 2. Aadhaar Card No. */}
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT2_Q2'
              label={Text({
                tid: "STUDENT_PT2_Q2",
                def: "aadhaar card",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
                {
                  pattern: /^[2-9]{1}[0-9]{11}$/, // Aadhaar must be 12 digits and should not start with 0 or 1
                  message: Text({
                    tid: "aadhaar_card_validation",
                    def: "Aadhaar must be 12 digits and should not start with 0 or 1",
                  }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                maxLength={12}
                onKeyDown={allowOnlyNumericInput_onKeyDown}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT2_Q2", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {/* 3. address with pincode */}
          <Col
            xs={24}
            lg={12}
            xl={12}
          >
            <Form.Item
              name='STUDENT_PT2_Q3'
              label={Text({
                tid: "STUDENT_PT2_Q3",
                def: "address with pincode",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("STUDENT_PT2_Q3", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("STUDENT_PT2_Q3", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='STUDENT_PT2_Q3'
            />
          </Col>
        </Row>
        {/* 4. Brother Sister Details*/}
        <Row>
          <Col xs={24}>
            <Typography.Text>
              {Text({
                tid: "STUDENT_PT2_Q4",
                def: "Brother Sister Details",
              })}
            </Typography.Text>
          </Col>
          <Col
            xs={24}
            className='onClickRenderFields'
          >
            <Form.List name='STUDENT_PT2_Q4'>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Space
                      key={key}
                      align='baseline'
                    >
                      <Row className='QuestionsSubSection'>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q4_A"]}
                            label={STUDENT_PT2_Q4_A}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q4",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q4")
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row className='QuestionsSubSection'>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q4_B"]}
                            label={STUDENT_PT2_Q4_B}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q4",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q4")
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row className='QuestionsSubSection'>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "STUDENT_PT2_Q4_C"]}
                            label={STUDENT_PT2_Q4_C}
                            rules={numberInputRules({
                              required: true,
                              allowNegative: false,
                              min: 0,
                              max: 120,
                            })}
                          >
                            <Input
                              disabled={disabled}
                              onKeyDown={allowOnlyNumericInput_onKeyDown}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q4",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q4")
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row className='QuestionsSubSection'>
                        <Col
                          xs={24}
                          lg={24}
                          xl={24}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "STUDENT_PT2_Q4_D"]}
                            label={STUDENT_PT2_Q4_D}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Radio.Group
                              disabled={disabled}
                              onChange={(e) => {
                                if (e.target.value === "NO") {
                                  form.setFieldValue(
                                    [
                                      "STUDENT_PT2_Q4",
                                      name,
                                      "STUDENT_PT2_Q4_E",
                                    ],
                                    ""
                                  );
                                }
                                handleFieldChange(
                                  "STUDENT_PT2_Q4",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q4")
                                  )
                                );
                              }}
                            >
                              <Radio value={eYES_OR_NO.YES}>{YES}</Radio>
                              <Radio value={eYES_OR_NO.NO}>{NO}</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row className='QuestionsSubSection'>
                        {form.getFieldValue([
                          "STUDENT_PT2_Q4",
                          name,
                          "STUDENT_PT2_Q4_D",
                        ]) === eYES_OR_NO.YES && (
                          <Col
                            xs={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              {...restField}
                              name={[name, "STUDENT_PT2_Q4_E"]}
                              label={STUDENT_PT2_Q4_E}
                              rules={[
                                {
                                  required:
                                    form.getFieldValue([
                                      "STUDENT_PT2_Q4",
                                      name,
                                      "STUDENT_PT2_Q4_D",
                                    ]) === eYES_OR_NO.YES
                                      ? true
                                      : false,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "STUDENT_PT2_Q4",
                                    JSON.stringify(
                                      form.getFieldValue("STUDENT_PT2_Q4")
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col xs={24}>
                          <Flex gap={30}>
                            {form.getFieldValue("STUDENT_PT2_Q4").length >
                              1 && (
                              <Form.Item>
                                <Button
                                  disabled={disabled}
                                  variant='filled'
                                  className='actionButton'
                                  onClick={() => {
                                    if (
                                      form.getFieldValue("STUDENT_PT2_Q4")
                                        .length > 1
                                    ) {
                                      remove(name);
                                      handleFieldChange(
                                        "STUDENT_PT2_Q4",
                                        JSON.stringify(
                                          form.getFieldValue("STUDENT_PT2_Q4")
                                        )
                                      );
                                    }
                                  }}
                                >
                                  {REMOVE}
                                </Button>
                              </Form.Item>
                            )}
                            {form.getFieldValue("STUDENT_PT2_Q4").length - 1 ===
                              index && (
                              <Form.Item>
                                <Button
                                  disabled={disabled}
                                  variant='filled'
                                  className='actionButton'
                                  onClick={() => {
                                    add();
                                    handleFieldChange(
                                      "STUDENT_PT2_Q4",
                                      JSON.stringify(
                                        form.getFieldValue("STUDENT_PT2_Q4")
                                      )
                                    );
                                  }}
                                  block
                                >
                                  {ADD}
                                </Button>
                              </Form.Item>
                            )}
                          </Flex>
                        </Col>
                      </Row>
                      {form.getFieldValue("STUDENT_PT2_Q4").length - 1 >
                        index && <div className='divider'></div>}
                    </Space>
                  ))}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* 5. Passport Size Photo */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT2_Q5'
              label={Text({
                tid: "STUDENT_PT2_Q5",
                def: "Passport Size Photo",
              })}
              rules={[
                {
                  required:
                    attachmentId ||
                    (documentsData?.length &&
                      documentsData.find(
                        (doc: any) => doc.labelName === "STUDENT_PT2_Q5"
                      ))
                      ? false
                      : true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                type='file'
                accept='.jpg,.jpeg,.png,.pdf'
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (!validateFile(file as File).valid) {
                    onShowToast({
                      type: ToastType.error,
                      title: <CloseOutlined />,
                      position: ToastOpen.leftBottom,
                      content: validateFile(file as File).error,
                    });
                    e.target.value = "";
                    form.resetFields(["STUDENT_PT2_Q5"]);
                  } else if (file) {
                    uploadDocument(file, eDocType.OTHER, "STUDENT_PT2_Q5");
                  }
                }}
                // onChange={(e) => {
                //   if (e.target.files && e.target.files[0]) {
                //     uploadDocument(
                //       e.target.files[0],
                //       eDocType.OTHER,
                //       "STUDENT_PT2_Q5"
                //     );
                //   }
                // }}
              />
            </Form.Item>
          </Col>
          <Col xs={24}>
            {attachmentId ? (
              <div className='previewLink'>
                <span>
                  {Text({
                    tid: "ATTACHED_DOCUMENT",
                    def: "Attached Document",
                  })}
                  :
                </span>
                <a
                  href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${attachmentId}`}
                  target='_blank'
                  rel='noreferrer'
                  className='primary-link'
                >
                  {PREVIEW}
                </a>
              </div>
            ) : (
              documentsData &&
              documentsData.length > 0 &&
              documentsData
                .filter((doc: any) => doc.labelName === "STUDENT_PT2_Q5")
                .map((doc: any) => (
                  <div className='previewLink'>
                    <span>
                      {Text({
                        tid: "ATTACHED_DOCUMENT",
                        def: "Attached Document",
                      })}
                      :
                    </span>
                    <a
                      href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${doc.docPath}`}
                      target='_blank'
                      rel='noreferrer'
                      className='primary-link'
                    >
                      {doc.docName}
                    </a>
                  </div>
                ))
            )}
          </Col>
        </Row>
        {/* 6. वेदाध्ययन का क्रम व उत्तीर्ण परिक्षाएं: */}
        <Row>
          <Col
            xs={24}
            className='onClickRenderFields'
          >
            <Typography.Text>
              {Text({
                tid: "STUDENT_PT2_Q6",
                def: "वेदाध्ययन का क्रम व उत्तीर्ण परिक्षाएं:",
              })}
            </Typography.Text>
            <Typography.Text type='secondary'>
              {Text({
                tid: "STUDENT_PT2_Q6_A",
                def: "यदि किसी एक स्तर पर एक से अधिक बार, अलग-अलग संस्थाओं में परीक्षा दी है, तो काल क्रम में सभी परीक्षाओं का विवरण दीजिये। यदि एक से अधिक वेद/शाखा का अध्ययन किया है, तो स्ववेदशाखा अध्ययन का विवरण देने के बाद अन्य अध्ययन का विवरण दीजिये।)",
              })}
            </Typography.Text>
            <Form.List name='STUDENT_PT2_Q6'>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => {
                    return (
                      <Space
                        key={key}
                        align='baseline'
                        className='QuestionsSubSection'
                      >
                        <Row>
                          <Col
                            xs={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "STUDENT_PT2_Q6_G"]}
                              label={STUDENT_PT2_Q6_G}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                type='month'
                                onClick={(e) => e.currentTarget.showPicker()}
                                max={disableFutureDates_on_input_month_max()}
                                onChange={() =>
                                  handleFieldChange(
                                    "STUDENT_PT2_Q6",
                                    serializeTableData(
                                      form.getFieldValue("STUDENT_PT2_Q6"),
                                      ["STUDENT_PT2_Q6_F"]
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            xs={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "STUDENT_PT2_Q6_B"]}
                              label={STUDENT_PT2_Q6_B}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                type='month'
                                onClick={(e) => e.currentTarget.showPicker()}
                                max={disableFutureDates_on_input_month_max()}
                                onChange={() =>
                                  handleFieldChange(
                                    "STUDENT_PT2_Q6",
                                    serializeTableData(
                                      form.getFieldValue("STUDENT_PT2_Q6"),
                                      ["STUDENT_PT2_Q6_F"]
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            xs={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "STUDENT_PT2_Q6_C"]}
                              label={STUDENT_PT2_Q6_C}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "STUDENT_PT2_Q6",
                                    serializeTableData(
                                      form.getFieldValue("STUDENT_PT2_Q6"),
                                      ["STUDENT_PT2_Q6_F"]
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            xs={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "STUDENT_PT2_Q6_D"]}
                              label={STUDENT_PT2_Q6_D}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "STUDENT_PT2_Q6",
                                    serializeTableData(
                                      form.getFieldValue("STUDENT_PT2_Q6"),
                                      ["STUDENT_PT2_Q6_F"]
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            xs={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "STUDENT_PT2_Q6_E"]}
                              label={STUDENT_PT2_Q6_E}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "STUDENT_PT2_Q6",
                                    serializeTableData(
                                      form.getFieldValue("STUDENT_PT2_Q6"),
                                      ["STUDENT_PT2_Q6_F"]
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            xs={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "STUDENT_PT2_Q6_F"]}
                              label={STUDENT_PT2_Q6_F}
                              rules={[
                                {
                                  required:
                                    form.getFieldValue([
                                      "STUDENT_PT2_Q6",
                                      name,
                                      "STUDENT_PT2_Q6_DOC",
                                    ])?.length > 0
                                      ? false
                                      : true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                type='file'
                                onChange={(e) => {
                                  const file = e.target.files?.[0];
                                  const validation = validateFile(file as File);

                                  if (!validation.valid) {
                                    onShowToast({
                                      type: ToastType.error,
                                      title: <CloseOutlined />,
                                      position: ToastOpen.leftBottom,
                                      content: validation.error,
                                    });

                                    // ✅ Clear the input manually
                                    e.target.value = "";

                                    // ✅ Optionally clear related form value
                                    const current =
                                      form.getFieldValue("STUDENT_PT2_Q6");
                                    const updatedJson = JSON.parse(
                                      JSON.stringify(current)
                                    ).map((item: any) => ({
                                      ...item,
                                      STUDENT_PT2_Q6_F: "",
                                    }));
                                    handleFieldChange(
                                      "STUDENT_PT2_Q6",
                                      serializeTableData(updatedJson, [
                                        "STUDENT_PT2_Q6_F",
                                      ])
                                    );
                                  } else if (file) {
                                    handleFileUpload(
                                      e,
                                      form,
                                      index,
                                      name.toString(),
                                      "STUDENT_PT2_Q6",
                                      "STUDENT_PT2_Q6_F",
                                      handleFieldChange,
                                      uploadDocument
                                    );
                                  }
                                }}
                                accept='.jpg,.jpeg,.png,.pdf'
                                // onChange={(e) => {
                                //   const file = e.target.files?.[0];
                                //   if (!validateFile(file as File).valid) {
                                //     onShowToast({
                                //       type: ToastType.error,
                                //       title: <CloseOutlined />,
                                //       position: ToastOpen.leftBottom,
                                //       content: validateFile(file as File).error,
                                //     });
                                //     e.target.value = "";
                                //     form.resetFields(["STUDENT_PT2_Q6"]);
                                //   } else if (file) {
                                //     handleFileUpload(
                                //       e,
                                //       form,
                                //       index,
                                //       name.toString(),
                                //       "STUDENT_PT2_Q6",
                                //       "STUDENT_PT2_Q6_F",
                                //       handleFieldChange,
                                //       uploadDocument
                                //     );
                                //   }
                                // }}
                              />
                            </Form.Item>
                            {form.getFieldValue([
                              "STUDENT_PT2_Q6",
                              name,
                              "STUDENT_PT2_Q6_DOC",
                            ]) && (
                              <div className='previewLink'>
                                <span>{ATTACHED_DOC}</span>
                                <a
                                  href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${form.getFieldValue(["STUDENT_PT2_Q6", name, "STUDENT_PT2_Q6_DOC"])}`}
                                  target='_blank'
                                  rel='noreferrer'
                                  className='primary-link'
                                >
                                  {PREVIEW}
                                </a>
                              </div>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          {/* Add Remove Button */}
                          <Col xs={24}>
                            <Flex gap={30}>
                              {form.getFieldValue("STUDENT_PT2_Q6").length >
                                1 && (
                                <Form.Item>
                                  <Button
                                    disabled={disabled}
                                    variant='filled'
                                    className='actionButton'
                                    onClick={() => {
                                      if (
                                        form.getFieldValue("STUDENT_PT2_Q6")
                                          .length > 1
                                      ) {
                                        remove(name);
                                        // const updatedJSON = JSON.parse(
                                        //   JSON.stringify(
                                        //     form.getFieldValue("STUDENT_PT2_Q6")
                                        //   )
                                        // ).map((item: any) => ({
                                        //   ...item,
                                        //   STUDENT_PT2_Q6_F: "",
                                        // }));

                                        serializeTableData(
                                          form.getFieldValue("STUDENT_PT2_Q6"),
                                          ["STUDENT_PT2_Q6_F"]
                                        );
                                      }
                                    }}
                                  >
                                    {REMOVE}
                                  </Button>
                                </Form.Item>
                              )}
                              {form.getFieldValue("STUDENT_PT2_Q6").length -
                                1 ===
                                index && (
                                <Form.Item>
                                  <Button
                                    disabled={disabled}
                                    variant='filled'
                                    className='actionButton'
                                    onClick={() => {
                                      add();
                                      handleFieldChange(
                                        "STUDENT_PT2_Q6",
                                        serializeTableData(
                                          form.getFieldValue("STUDENT_PT2_Q6"),
                                          ["STUDENT_PT2_Q6_F"]
                                        )
                                      );
                                    }}
                                    block
                                  >
                                    {ADD}
                                  </Button>
                                </Form.Item>
                              )}
                            </Flex>
                          </Col>
                        </Row>
                        {form.getFieldValue("STUDENT_PT2_Q6").length - 1 >
                          index && <div className='divider'></div>}
                      </Space>
                    );
                  })}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* 7. अपने सभी वेदाध्यापक व वेदविद्यालय के नाम जहाँ आपने वेदाध्ययन किया */}
        <Row>
          <Col
            xs={24}
            className='onClickRenderFields'
          >
            <Typography.Text>
              {Text({
                tid: "STUDENT_PT2_Q7",
                def: "Ved Teacher And Student Details",
              })}
            </Typography.Text>

            <Form.List name='STUDENT_PT2_Q7'>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Space
                      key={key}
                      align='baseline'
                      className='QuestionsSubSection'
                    >
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q7_D"]}
                            label={STUDENT_PT2_Q7_D}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              type='month'
                              onClick={(e) => e.currentTarget.showPicker()}
                              max={disableFutureDates_on_input_month_max()}
                              onChange={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q7",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q7")
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q7_A"]}
                            label={STUDENT_PT2_Q7_A}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              type='month'
                              onClick={(e) => e.currentTarget.showPicker()}
                              max={disableFutureDates_on_input_month_max()}
                              onChange={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q7",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q7")
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={12}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q7_B"]}
                            label={STUDENT_PT2_Q7_B}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <>
                              <Input.TextArea
                                disabled={disabled}
                                onBlur={(e) => {
                                  handleFieldChange(
                                    "STUDENT_PT2_Q7",
                                    JSON.stringify(
                                      form.getFieldValue("STUDENT_PT2_Q7")
                                    )
                                  );
                                }}
                                onChange={(e) => {
                                  form.setFieldValue(
                                    [
                                      "STUDENT_PT2_Q7",
                                      name,
                                      "STUDENT_PT2_Q7_B",
                                    ],
                                    e.target.value
                                  );
                                }}
                                maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                                style={{ paddingBottom: 20 }}
                              />
                            </>
                          </Form.Item>
                          <LengthCounter
                            form={form}
                            fieldName={[
                              "STUDENT_PT2_Q7",
                              name.toString(),
                              "STUDENT_PT2_Q7_B",
                            ]}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q7_C"]}
                            label={STUDENT_PT2_Q7_C}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q7",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q7")
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        {/* Add Remove Button */}
                        <Col xs={24}>
                          <Flex gap={30}>
                            {form.getFieldValue("STUDENT_PT2_Q7").length >
                              1 && (
                              <Form.Item>
                                <Button
                                  disabled={disabled}
                                  variant='filled'
                                  className='actionButton'
                                  // onClick={() => remove(name)}
                                  onClick={() => {
                                    if (
                                      form.getFieldValue("STUDENT_PT2_Q7")
                                        .length > 1
                                    ) {
                                      remove(name);
                                      handleFieldChange(
                                        "STUDENT_PT2_Q7",
                                        JSON.stringify(
                                          form.getFieldValue("STUDENT_PT2_Q7")
                                        )
                                      );
                                    }
                                  }}
                                >
                                  {REMOVE}
                                </Button>
                              </Form.Item>
                            )}
                            {form.getFieldValue("STUDENT_PT2_Q7").length - 1 ===
                              index && (
                              <Form.Item>
                                <Button
                                  disabled={disabled}
                                  variant='filled'
                                  className='actionButton'
                                  onClick={() => {
                                    add();
                                    handleFieldChange(
                                      "STUDENT_PT2_Q7",
                                      JSON.stringify(
                                        form.getFieldValue("STUDENT_PT2_Q7")
                                      )
                                    );
                                  }}
                                  block
                                >
                                  {ADD}
                                </Button>
                              </Form.Item>
                            )}
                          </Flex>
                        </Col>
                      </Row>
                      {form.getFieldValue("STUDENT_PT2_Q7").length - 1 >
                        index && <div className='divider'></div>}
                    </Space>
                  ))}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* 8. अधीत वेद ग्रन्थों का विवरण */}
        <Row>
          <Col
            xs={24}
            className='onClickRenderFields'
          >
            <Typography.Text>
              {Text({
                tid: "STUDENT_PT2_Q8",
                def: "Ved Studies Details ",
              })}
            </Typography.Text>
            <Typography.Text type='secondary'>
              {Text({
                tid: "STUDENT_PT2_Q8_SUBTEXT",
                def: "अधीत वेदशाखा के उन सभी ग्रन्थों का वर्णन कीजिये जिनका अध्ययन कर आप परीक्षा उत्तीर्ण कर चुके हैं। यदि किसी ग्रन्थ का अध्ययन कर रहे हैं, परन्तु परीक्षा शेष है, तो उसका भी उल्लेख कीजिये। अधीत वेदशाखा के अलावा किसी अन्य वेद,शाखा या ग्रन्थ का अध्ययन किया है, तो अन्त में ऐसे सभी ग्रन्थों का विवरण दीजिये।)",
              })}
            </Typography.Text>
            <Form.List name='STUDENT_PT2_Q8'>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Space
                      key={key}
                      align='baseline'
                      className='QuestionsSubSection'
                    >
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q8_A"]}
                            label={STUDENT_PT2_Q8_A}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              type='month'
                              onClick={(e) => e.currentTarget.showPicker()}
                              max={disableFutureDates_on_input_month_max()}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q8",
                                  serializeTableData(
                                    form.getFieldValue("STUDENT_PT2_Q8"),
                                    ["STUDENT_PT2_Q8_D"]
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q8_B"]}
                            label={STUDENT_PT2_Q8_B}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q8",
                                  serializeTableData(
                                    form.getFieldValue("STUDENT_PT2_Q8"),
                                    ["STUDENT_PT2_Q8_D"]
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q8_C"]}
                            label={STUDENT_PT2_Q8_C}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              type='month'
                              onClick={(e) => e.currentTarget.showPicker()}
                              max={disableFutureDates_on_input_month_max()}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q8",
                                  serializeTableData(
                                    form.getFieldValue("STUDENT_PT2_Q8"),
                                    ["STUDENT_PT2_Q8_D"]
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q8_D"]}
                            label={STUDENT_PT2_Q8_D}
                            rules={[
                              {
                                required:
                                  form.getFieldValue([
                                    "STUDENT_PT2_Q8",
                                    name,
                                    "STUDENT_PT2_Q8_DOC",
                                  ])?.length > 0
                                    ? false
                                    : true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              type='file'
                              onChange={(e) =>
                                handleFileUpload(
                                  e,
                                  form,
                                  index,
                                  name.toString(),
                                  "STUDENT_PT2_Q8",
                                  "STUDENT_PT2_Q8_D",
                                  handleFieldChange,
                                  uploadDocument
                                )
                              }
                            />
                          </Form.Item>
                          {form.getFieldValue([
                            "STUDENT_PT2_Q8",
                            name,
                            "STUDENT_PT2_Q8_DOC",
                          ]) && (
                            <div className='previewLink'>
                              <span>{ATTACHED_DOC}</span>
                              <a
                                href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${form.getFieldValue(["STUDENT_PT2_Q8", name, "STUDENT_PT2_Q8_DOC"])}`}
                                target='_blank'
                                rel='noreferrer'
                                className='primary-link'
                              >
                                {PREVIEW}
                              </a>
                            </div>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        {/* Add Remove Button */}
                        <Col xs={24}>
                          <Flex gap={30}>
                            {form.getFieldValue("STUDENT_PT2_Q8").length >
                              1 && (
                              <Form.Item>
                                <Button
                                  disabled={disabled}
                                  variant='filled'
                                  className='actionButton'
                                  onClick={() => {
                                    if (
                                      form.getFieldValue("STUDENT_PT2_Q8")
                                        .length > 1
                                    ) {
                                      remove(name);
                                      // //creating a deep copy
                                      // const updatedJSON = JSON.parse(
                                      //   JSON.stringify(
                                      //     form.getFieldValue("STUDENT_PT2_Q8")
                                      //   )
                                      // ).map((item: any) => ({
                                      //   ...item,
                                      //   STUDENT_PT2_Q8_D: "",
                                      // }));
                                      serializeTableData(
                                        form.getFieldValue("STUDENT_PT2_Q8"),
                                        ["STUDENT_PT2_Q8_D"]
                                      );
                                    }
                                  }}
                                >
                                  {REMOVE}
                                </Button>
                              </Form.Item>
                            )}

                            {form.getFieldValue("STUDENT_PT2_Q8").length - 1 ===
                              index && (
                              <Form.Item>
                                <Button
                                  disabled={disabled}
                                  variant='filled'
                                  className='actionButton'
                                  onClick={() => {
                                    add();
                                    handleFieldChange(
                                      "STUDENT_PT2_Q8",
                                      serializeTableData(
                                        form.getFieldValue("STUDENT_PT2_Q8"),
                                        ["STUDENT_PT2_Q8_D"]
                                      )
                                    );
                                  }}
                                  block
                                >
                                  {ADD}
                                </Button>
                              </Form.Item>
                            )}
                          </Flex>
                        </Col>
                      </Row>
                      {form.getFieldValue("STUDENT_PT2_Q8").length - 1 >
                        index && <div className='divider'></div>}
                    </Space>
                  ))}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* 9. आपके द्वारा अर्जित पुरस्कार / सम्मानों का विवरण: (कालक्रम में लिखें): */}
        <Row>
          <Col
            xs={24}
            className='onClickRenderFields'
          >
            <Typography.Text>
              {Text({
                tid: "STUDENT_PT2_Q9",
                def: "आपके द्वारा अर्जित पुरस्कार / सम्मानों का विवरण: (कालक्रम में लिखें):",
              })}
            </Typography.Text>
            <Form.List name='STUDENT_PT2_Q9'>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Space
                      key={key}
                      align='baseline'
                      className='QuestionsSubSection'
                    >
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q9_A"]}
                            label={STUDENT_PT2_Q9_A}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              type='month'
                              onClick={(e) => e.currentTarget.showPicker()}
                              max={disableFutureDates_on_input_month_max()}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q9",
                                  serializeTableData(
                                    form.getFieldValue("STUDENT_PT2_Q9"),
                                    ["STUDENT_PT2_Q9_D"]
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q9_B"]}
                            label={STUDENT_PT2_Q9_B}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q9",
                                  serializeTableData(
                                    form.getFieldValue("STUDENT_PT2_Q9"),
                                    ["STUDENT_PT2_Q9_D"]
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q9_C"]}
                            label={STUDENT_PT2_Q9_C}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q9",
                                  serializeTableData(
                                    form.getFieldValue("STUDENT_PT2_Q9"),
                                    ["STUDENT_PT2_Q9_D"]
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q9_D"]}
                            label={STUDENT_PT2_Q9_D}
                            rules={[
                              {
                                required:
                                  form.getFieldValue([
                                    "STUDENT_PT2_Q9",
                                    name,
                                    "STUDENT_PT2_Q9_DOC",
                                  ])?.length > 0
                                    ? false
                                    : true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              type='file'
                              onChange={(e) =>
                                handleFileUpload(
                                  e,
                                  form,
                                  index,
                                  name.toString(),
                                  "STUDENT_PT2_Q9",
                                  "STUDENT_PT2_Q9_D",
                                  handleFieldChange,
                                  uploadDocument
                                )
                              }
                            />
                          </Form.Item>
                          {form.getFieldValue([
                            "STUDENT_PT2_Q9",
                            name,
                            "STUDENT_PT2_Q9_DOC",
                          ]) && (
                            <div className='previewLink'>
                              <span>{ATTACHED_DOC}</span>
                              <a
                                href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${form.getFieldValue(["STUDENT_PT2_Q9", name, "STUDENT_PT2_Q9_DOC"])}`}
                                target='_blank'
                                rel='noreferrer'
                                className='primary-link'
                              >
                                {PREVIEW}
                              </a>
                            </div>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        {/* Add Remove Button */}
                        <Col xs={24}>
                          <Flex gap={30}>
                            {form.getFieldValue("STUDENT_PT2_Q9").length >
                              1 && (
                              <Form.Item>
                                <Button
                                  disabled={disabled}
                                  variant='filled'
                                  className='actionButton'
                                  onClick={() => {
                                    if (
                                      form.getFieldValue("STUDENT_PT2_Q9")
                                        .length > 1
                                    ) {
                                      remove(name);

                                      handleFieldChange(
                                        "STUDENT_PT2_Q9",
                                        serializeTableData(
                                          form.getFieldValue("STUDENT_PT2_Q9"),
                                          ["STUDENT_PT2_Q9_D"]
                                        )
                                      );
                                    }
                                  }}
                                >
                                  {REMOVE}
                                </Button>
                              </Form.Item>
                            )}
                            {form.getFieldValue("STUDENT_PT2_Q9").length - 1 ===
                              index && (
                              <Form.Item>
                                <Button
                                  disabled={disabled}
                                  variant='filled'
                                  className='actionButton'
                                  onClick={() => {
                                    add();
                                    handleFieldChange(
                                      "STUDENT_PT2_Q9",
                                      serializeTableData(
                                        form.getFieldValue("STUDENT_PT2_Q9"),
                                        ["STUDENT_PT2_Q9_D"]
                                      )
                                    );
                                  }}
                                  block
                                >
                                  {ADD}
                                </Button>
                              </Form.Item>
                            )}
                          </Flex>
                        </Col>
                      </Row>
                      {form.getFieldValue("STUDENT_PT2_Q9").length - 1 >
                        index && <div className='divider'></div>}
                    </Space>
                  ))}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* 10. Support of Other Initiative */}
        <Row>
          <Col
            xs={24}
            className='onClickRenderFields'
          >
            <Typography.Text>
              {Text({
                tid: "STUDENT_PT2_Q10",
                def: "Support of Other Initiative",
              })}
            </Typography.Text>
            <Form.List name='STUDENT_PT2_Q10'>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Space
                      key={key}
                      align='baseline'
                      className='QuestionsSubSection'
                    >
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q10_A"]}
                            label={STUDENT_PT2_Q10_A}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q10",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q10")
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q10_B"]}
                            label={STUDENT_PT2_Q10_B}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q10",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q10")
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q10_C"]}
                            label={STUDENT_PT2_Q10_C}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              onBlur={() =>
                                handleFieldChange(
                                  "STUDENT_PT2_Q10",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q10")
                                  )
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={24}
                          lg={12}
                          xl={8}
                        >
                          <Form.Item
                            className='w-full'
                            {...restField}
                            name={[name, "STUDENT_PT2_Q10_D"]}
                            label={STUDENT_PT2_Q10_D}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled}
                              type='month'
                              onClick={(e) => e.currentTarget.showPicker()}
                              max={disableFutureDates_on_input_month_max()}
                              placeholder='Select Year'
                              onChange={(e) => {
                                handleFieldChange(
                                  "STUDENT_PT2_Q10",
                                  JSON.stringify(
                                    form.getFieldValue("STUDENT_PT2_Q10")
                                  )
                                );
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        {/* Add Remove Button */}
                        <Col xs={24}>
                          <Flex gap={30}>
                            {form.getFieldValue("STUDENT_PT2_Q10").length >
                              1 && (
                              <Form.Item>
                                <Button
                                  disabled={disabled}
                                  variant='filled'
                                  className='actionButton'
                                  onClick={() => {
                                    if (
                                      form.getFieldValue("STUDENT_PT2_Q10")
                                        .length > 1
                                    ) {
                                      remove(name);
                                      handleFieldChange(
                                        "STUDENT_PT2_Q10",
                                        JSON.stringify(
                                          form.getFieldValue("STUDENT_PT2_Q10")
                                        )
                                      );
                                    }
                                  }}
                                >
                                  {REMOVE}
                                </Button>
                              </Form.Item>
                            )}

                            {form.getFieldValue("STUDENT_PT2_Q10").length -
                              1 ===
                              index && (
                              <Form.Item>
                                <Button
                                  disabled={disabled}
                                  variant='filled'
                                  className='actionButton'
                                  onClick={() => {
                                    add();
                                    handleFieldChange(
                                      "STUDENT_PT2_Q10",
                                      JSON.stringify(
                                        form.getFieldValue("STUDENT_PT2_Q10")
                                      )
                                    );
                                  }}
                                  block
                                >
                                  {ADD}
                                </Button>
                              </Form.Item>
                            )}
                          </Flex>
                        </Col>
                      </Row>
                      {form.getFieldValue("STUDENT_PT2_Q10").length - 1 >
                        index && <div className='divider'></div>}
                    </Space>
                  ))}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* AFFIDAVIT TITLE */}
        <div
          id='st_form2_applicant_affidavit'
          className='affidavitSection'
        >
          <Row>
            <Col>
              <Typography.Text>
                {Text({
                  tid: "AFFIDAVIT_TITLE",
                  def: "Affidavit",
                })}
              </Typography.Text>
            </Col>
          </Row>
          <Row className='affidavitRow'>
            <Col xs={24}>
              <Typography.Text
                type='secondary'
                style={{
                  maxWidth: "max-content",
                }}
              >
                {Text({
                  tid: "AAVEDAK_AFFIDAVIT_INTRO_11",
                  def: "मैं (आवेदक का पूरा नाम)",
                })}
              </Typography.Text>
              <Form.Item
                name='STUDENT_PT2_Q11'
                className='affidavitRowInput'
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input
                  disabled={applyPdfStyles ? false : true}
                  id={applyPdfStyles ? "affidavit_input" : ""}
                  onBlur={(e) =>
                    handleFieldChange("STUDENT_PT2_Q11", e.target.value)
                  }
                />
              </Form.Item>
              <Typography.Text
                type='secondary'
                style={{ maxWidth: "max-content", marginBottom: "0" }}
              >
                {Text({
                  tid: "AAVEDAK_AFFIDAVIT_INTRO_12",
                  def: "एतद् द्वारा सत्यनिष्ठा से यह प्रमाणित करता हूँ कि:",
                })}
              </Typography.Text>
            </Col>
          </Row>
          {/* AFFIDAVIT DESCRIPTION */}
          <Row>
            <Col>
              <ul>
                <li>
                  <Typography.Text type='secondary'>
                    {Text({
                      tid: "AFFIDAVIT_CLAUSE_1",
                      def: "AFFIDAVIT_CLAUSE_1",
                    })}
                  </Typography.Text>
                </li>

                <li>
                  <Typography.Text type='secondary'>
                    {Text({
                      tid: "AFFIDAVIT_CLAUSE_2",
                      def: "AFFIDAVIT_CLAUSE_2",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text type='secondary'>
                    {Text({
                      tid: "AFFIDAVIT_CLAUSE_3",
                      def: "AFFIDAVIT_CLAUSE_3",
                    })}
                  </Typography.Text>
                </li>
              </ul>
              <div>
                <Typography.Text type='secondary'>
                  {Text({
                    tid: "AFFIDAVIT_VERIFICATION",
                    def: "AFFIDAVIT_VERIFICATION",
                  })}
                </Typography.Text>
                <Typography.Text type='secondary'>
                  {Text({
                    tid: "AFFIDAVIT_UNDERSTANDING",
                    def: "AFFIDAVIT_UNDERSTANDING",
                  })}
                </Typography.Text>
                <Typography.Text type='secondary'>
                  {Text({
                    tid: "AFFIDAVIT_ACCEPTANCE",
                    def: "AFFIDAVIT_ACCEPTANCE",
                  })}
                </Typography.Text>
              </div>
            </Col>
          </Row>
          {/* AFFIDAVIT QUESTION */}
          <Row className='QuestionsSubSection affidavitQuestionFirst'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "FULL_NAME_OF_APPLICANT",
                      def: "FULL_NAME_OF_APPLICANT",
                    })}
                  </span>
                  <Form.Item
                    name='STUDENT_PT2_Q12'
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={applyPdfStyles ? false : true}
                      onBlur={(e) =>
                        handleFieldChange("STUDENT_PT2_Q12", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='STUDENT_PT2_Q12'
                  label={Text({
                    tid: "FULL_NAME_OF_APPLICANT",
                    def: "FULL_NAME_OF_APPLICANT",
                  })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={applyPdfStyles ? false : true}
                    onBlur={(e) =>
                      handleFieldChange("STUDENT_PT2_Q12", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row className='QuestionsSubSection'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({ tid: "PLACE", def: "PLACE" })}
                  </span>
                  <Form.Item
                    name='STUDENT_PT2_Q13'
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={disabled}
                      onBlur={(e) =>
                        handleFieldChange("STUDENT_PT2_Q13", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='STUDENT_PT2_Q13'
                  label={Text({ tid: "PLACE", def: "PLACE" })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("STUDENT_PT2_Q13", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row className='QuestionsSubSection'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({ tid: "DATE", def: "DATE" })}
                  </span>
                  <Form.Item
                    name='STUDENT_PT2_Q14'
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={disabled}
                      type={applyPdfStyles ? undefined : "date"}
                      max={
                        applyPdfStyles
                          ? undefined
                          : disableFutureDates_on_input_date_max()
                      }
                      onChange={(e) =>
                        handleFieldChange("STUDENT_PT2_Q14", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='STUDENT_PT2_Q14'
                  label={Text({ tid: "DATE", def: "DATE" })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={disabled}
                    type={applyPdfStyles ? undefined : "date"}
                    max={
                      applyPdfStyles
                        ? undefined
                        : disableFutureDates_on_input_date_max()
                    }
                    onChange={(e) =>
                      handleFieldChange("STUDENT_PT2_Q14", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          {applyPdfStyles ? (
            <Row className='QuestionsSubSection'>
              <Col
                xs={24}
                lg={12}
                xl={8}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "SIGNATURE_OF_THE_APPLICANT",
                      def: "SIGNATURE_OF_THE_APPLICANT",
                    })}
                  </span>
                  <Form.Item style={{ marginBottom: 0, flex: 1 }}>
                    <Input id={applyPdfStyles ? "affidavit_input" : ""} />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          ) : null}
        </div>
        <div className='affidavitSection'>
          {!disabled && (
            <Row className='mb-15 QuestionsSubSection'>
              <Button
                type='default'
                onClick={() =>
                  handleGeneratePDF(
                    "st_form2_applicant_affidavit",
                    "student_form2_applicant_affidavit"
                  )
                }
                className='downloadAffidavitButton'
              >
                {Text({
                  tid: "DOWNLOAD_AFFIDAVIT",
                  def: "Download affidavit",
                })}
              </Button>
            </Row>
          )}
          <Row className=' QuestionsSubSection'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='STUDENT_PT2_Q26'
                label={Text({
                  tid: "UPLOAD_AFFIDAVIT",
                  def: "Upload affidavit",
                })}
                rules={[
                  {
                    required:
                      applicantAffidavit ||
                      (documentsData?.length &&
                        documentsData.find(
                          (doc: any) => doc.labelName === "STUDENT_PT2_Q26"
                        ))
                        ? false
                        : true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input
                  type='file'
                  disabled={disabled}
                  accept='.jpg,.jpeg,.png,.pdf'
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (!validateFile(file as File).valid) {
                      onShowToast({
                        type: ToastType.error,
                        title: <CloseOutlined />,
                        position: ToastOpen.leftBottom,
                        content: validateFile(file as File).error,
                      });
                      e.target.value = "";
                      form.resetFields(["STUDENT_PT2_Q26"]);
                    } else if (file) {
                      uploadDocument(file, eDocType.OTHER, "STUDENT_PT2_Q26");
                    }
                  }}
                  // onChange={(e) => {
                  //   if (e.target.files && e.target.files[0]) {
                  //     uploadDocument(
                  //       e.target.files[0],
                  //       eDocType.OTHER,
                  //       "STUDENT_PT2_Q26"
                  //     );
                  //   }
                  // }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              {applicantAffidavit ? (
                <div className='previewLink'>
                  <span>
                    {Text({
                      tid: "ATTACHED_DOCUMENT",
                      def: "Attached Document",
                    })}
                    :
                  </span>
                  <a
                    href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${applicantAffidavit}`}
                    target='_blank'
                    rel='noreferrer'
                    className='primary-link'
                  >
                    {Text({
                      tid: "PREVIEW",
                      def: "Preview",
                    })}
                  </a>
                </div>
              ) : (
                documentsData &&
                documentsData.length > 0 &&
                documentsData
                  .filter((doc: any) => doc.labelName === "STUDENT_PT2_Q26")
                  .map((doc: any) => (
                    <div className='previewLink'>
                      <span>
                        {Text({
                          tid: "ATTACHED_DOCUMENT",
                          def: "Attached Document",
                        })}
                        :
                      </span>
                      <a
                        href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${doc.docPath}`}
                        target='_blank'
                        rel='noreferrer'
                        className='primary-link'
                      >
                        {doc.docName}
                      </a>
                    </div>
                  ))
              )}
            </Col>
          </Row>
        </div>
        {/* DETAILS WITH CURRENT VEDGURU*/}
        <Row>
          <Typography.Text>
            {Text({
              tid: "STUDENT_PT2_Q15_HEADING",
              def: " ",
            })}
          </Typography.Text>
          <Col xs={24}>
            {/* 1. Ved guru name */}
            <Row className='QuestionsSubSection'>
              <Col
                xs={24}
                lg={12}
                xl={8}
              >
                <Form.Item
                  name='STUDENT_PT2_Q15'
                  label={Text({
                    tid: "STUDENT_PT2_Q15",
                    def: "VED GURU Name",
                  })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("STUDENT_PT2_Q15", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className='QuestionsSubSection'>
              <Col
                xs={24}
                lg={12}
                xl={8}
              >
                <Form.Item
                  name='STUDENT_PT2_Q16'
                  label={Text({
                    tid: "STUDENT_PT2_Q16",
                    def: "VED GURU studies",
                  })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("STUDENT_PT2_Q16", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className='QuestionsSubSection'>
              <Col
                xs={24}
                lg={12}
                xl={8}
              >
                <Form.Item
                  name='STUDENT_PT2_Q17_A'
                  label={Text({
                    tid: "STUDENT_PT2_Q17_A",
                    def: "Highest qualification of the Ved teacher",
                  })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("STUDENT_PT2_Q17_A", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className='QuestionsSubSection'>
              <Col
                xs={24}
                lg={12}
                xl={8}
              >
                <Form.Item
                  name='STUDENT_PT2_Q17'
                  label={Text({
                    tid: "STUDENT_PT2_Q17",
                    def: "VED GURU studies",
                  })}
                  // rules={[
                  //   {
                  //     required:
                  //       PT2_Q17_DOC ||
                  //       (documentsData?.length &&
                  //         documentsData.find(
                  //           (doc: any) => doc.labelName === "STUDENT_PT2_Q17_A"
                  //         ))
                  //         ? false
                  //         : true,
                  //     message: Text({ tid: "REQUIRED", def: "Required" }),
                  //   },
                  // ]}
                >
                  <Input
                    disabled={disabled}
                    type='file'
                    // onChange={(e) => {
                    //   if (e.target.files && e.target.files[0]) {
                    //     uploadDocument(
                    //       e.target.files[0],
                    //       eDocType.OTHER,
                    //       "STUDENT_PT2_Q17"
                    //     );
                    //   }
                    // }}
                    accept='.jpg,.jpeg,.png,.pdf'
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (!validateFile(file as File).valid) {
                        onShowToast({
                          type: ToastType.error,
                          title: <CloseOutlined />,
                          position: ToastOpen.leftBottom,
                          content: validateFile(file as File).error,
                        });
                        e.target.value = "";
                        form.resetFields(["STUDENT_PT2_Q17"]);
                      } else if (file) {
                        uploadDocument(file, eDocType.OTHER, "STUDENT_PT2_Q17");
                      }
                    }}
                  />
                </Form.Item>
                <Col xs={24}>
                  {PT2_Q17_DOC ? (
                    <div className='previewLink'>
                      <span>
                        {Text({
                          tid: "ATTACHED_DOCUMENT",
                          def: "Attached Document",
                        })}
                        :
                      </span>
                      <a
                        href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${PT2_Q17_DOC}`}
                        target='_blank'
                        rel='noreferrer'
                        className='primary-link'
                      >
                        {PREVIEW}
                      </a>
                    </div>
                  ) : (
                    documentsData &&
                    documentsData.length > 0 &&
                    documentsData
                      .filter((doc: any) => doc.labelName === "STUDENT_PT2_Q17")
                      .map((doc: any) => (
                        <div className='previewLink'>
                          <span>
                            {Text({
                              tid: "ATTACHED_DOCUMENT",
                              def: "Attached Document",
                            })}
                            :
                          </span>
                          <a
                            href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${doc.docPath}`}
                            target='_blank'
                            rel='noreferrer'
                            className='primary-link'
                          >
                            {doc.docName}
                          </a>
                        </div>
                      ))
                  )}
                </Col>
              </Col>
            </Row>
            {/* <Row className="QuestionsSubSection">
              <Col xs={24}>
                <Form.Item
                  name="STUDENT_PT2_Q18"
                  label={Text({
                    tid: "STUDENT_PT2_Q18",
                    def: "VED GURU studies",
                  })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <>
                    <Input.TextArea
                      disabled={disabled}
                      onBlur={(e) => {
                        handleFieldChange("STUDENT_PT2_Q18", e.target.value);
                      }}
                      onChange={(e) => {
                        form.setFieldValue("STUDENT_PT2_Q18", e.target.value);
                      }}
                      maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                      style={{ paddingBottom: 20 }}
                    />
                  </>
                </Form.Item>
                <LengthCounter form={form} fieldName="STUDENT_PT2_Q18" />
              </Col>
            </Row> */}
            <Row>
              <Col
                xs={24}
                className='onClickRenderFields'
              >
                <Typography.Text type='secondary'>
                  {Text({
                    tid: "STUDENT_PT2_Q19_HEADING",
                    def: " ",
                  })}
                </Typography.Text>

                <Form.List name='STUDENT_PT2_Q19'>
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <Space
                          key={key}
                          align='baseline'
                          className='QuestionsSubSection'
                        >
                          <Row>
                            <Col
                              xs={24}
                              lg={24}
                              xl={24}
                            >
                              <Form.Item
                                {...restField}
                                name={[name, "STUDENT_PT2_Q19_A"]}
                                label={STUDENT_PT2_Q19_A}
                                rules={[
                                  {
                                    required: true,
                                    message: REQUIRED,
                                  },
                                ]}
                              >
                                <Radio.Group
                                  disabled={disabled}
                                  onChange={(e) => {
                                    if (e.target.value === "NO") {
                                      form.setFieldValue(
                                        [
                                          "STUDENT_PT2_Q19",
                                          name,
                                          "STUDENT_PT2_Q19_A_DESC",
                                        ],
                                        ""
                                      );
                                    }
                                    handleFieldChange(
                                      "STUDENT_PT2_Q19",
                                      JSON.stringify(
                                        form.getFieldValue("STUDENT_PT2_Q19")
                                      )
                                    );
                                  }}
                                >
                                  <Radio value='YES'>{YES}</Radio>
                                  <Radio value='NO'>{NO}</Radio>
                                </Radio.Group>
                              </Form.Item>

                              {form.getFieldValue([
                                "STUDENT_PT2_Q19",
                                name,
                                "STUDENT_PT2_Q19_A",
                              ]) === eYES_OR_NO.YES && (
                                <>
                                  <Form.Item
                                    name={[name, "STUDENT_PT2_Q19_A_DESC"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                    label={DESC}
                                  >
                                    <>
                                      <Input.TextArea
                                        disabled={disabled}
                                        onBlur={() =>
                                          handleFieldChange(
                                            "STUDENT_PT2_Q19",
                                            JSON.stringify(
                                              form.getFieldValue(
                                                "STUDENT_PT2_Q19"
                                              )
                                            )
                                          )
                                        }
                                        onChange={(e) => {
                                          form.setFieldValue(
                                            [
                                              "STUDENT_PT2_Q19",
                                              name,
                                              "STUDENT_PT2_Q19_A_DESC",
                                            ],
                                            e.target.value
                                          );
                                        }}
                                        maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                                        style={{ paddingBottom: 20 }}
                                      />
                                    </>
                                  </Form.Item>
                                  <LengthCounter
                                    form={form}
                                    fieldName={[
                                      "STUDENT_PT2_Q19",
                                      name.toString(),
                                      "STUDENT_PT2_Q19_A_DESC",
                                    ]}
                                  />
                                </>
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={24}
                              lg={24}
                              xl={24}
                            >
                              <Form.Item
                                {...restField}
                                name={[name, "STUDENT_PT2_Q19_B"]}
                                label={STUDENT_PT2_Q19_B}
                                rules={[
                                  {
                                    required: true,
                                    message: REQUIRED,
                                  },
                                ]}
                              >
                                <Radio.Group
                                  disabled={disabled}
                                  onChange={(e) => {
                                    if (e.target.value === "NO") {
                                      form.setFieldValue(
                                        [
                                          "STUDENT_PT2_Q19",
                                          name,
                                          "STUDENT_PT2_Q19_B_DESC",
                                        ],
                                        ""
                                      );
                                    }
                                    handleFieldChange(
                                      "STUDENT_PT2_Q19",
                                      JSON.stringify(
                                        form.getFieldValue("STUDENT_PT2_Q19")
                                      )
                                    );
                                  }}
                                >
                                  <Radio value='YES'>{YES}</Radio>
                                  <Radio value='NO'>{NO}</Radio>
                                </Radio.Group>
                              </Form.Item>
                              {form.getFieldValue([
                                "STUDENT_PT2_Q19",
                                name,
                                "STUDENT_PT2_Q19_B",
                              ]) === eYES_OR_NO.YES && (
                                <>
                                  <Form.Item
                                    name={[name, "STUDENT_PT2_Q19_B_DESC"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                    label={DESC}
                                  >
                                    <>
                                      <Input.TextArea
                                        disabled={disabled}
                                        onBlur={() =>
                                          handleFieldChange(
                                            "STUDENT_PT2_Q19",
                                            JSON.stringify(
                                              form.getFieldValue(
                                                "STUDENT_PT2_Q19"
                                              )
                                            )
                                          )
                                        }
                                        onChange={(e) => {
                                          form.setFieldValue(
                                            [
                                              "STUDENT_PT2_Q19",
                                              name,
                                              "STUDENT_PT2_Q19_B_DESC",
                                            ],
                                            e.target.value
                                          );
                                        }}
                                        maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                                        style={{ paddingBottom: 20 }}
                                      />
                                    </>
                                  </Form.Item>
                                  <LengthCounter
                                    form={form}
                                    fieldName={[
                                      "STUDENT_PT2_Q19",
                                      name.toString(),
                                      "STUDENT_PT2_Q19_B_DESC",
                                    ]}
                                  />
                                </>
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={24}
                              lg={24}
                              xl={24}
                            >
                              <Form.Item
                                {...restField}
                                name={[name, "STUDENT_PT2_Q19_C"]}
                                label={STUDENT_PT2_Q19_C}
                                rules={[
                                  {
                                    required: true,
                                    message: REQUIRED,
                                  },
                                ]}
                              >
                                <Radio.Group
                                  disabled={disabled}
                                  onChange={(e) => {
                                    if (e.target.value === "NO") {
                                      form.setFieldValue(
                                        [
                                          "STUDENT_PT2_Q19",
                                          name,
                                          "STUDENT_PT2_Q19_C_DESC",
                                        ],
                                        ""
                                      );
                                    }
                                    handleFieldChange(
                                      "STUDENT_PT2_Q19",
                                      JSON.stringify(
                                        form.getFieldValue("STUDENT_PT2_Q19")
                                      )
                                    );
                                  }}
                                >
                                  <Radio value='YES'>{YES}</Radio>
                                  <Radio value='NO'>{NO}</Radio>
                                </Radio.Group>
                              </Form.Item>
                              {form.getFieldValue([
                                "STUDENT_PT2_Q19",
                                name,
                                "STUDENT_PT2_Q19_C",
                              ]) === eYES_OR_NO.YES && (
                                <>
                                  <Form.Item
                                    name={[name, "STUDENT_PT2_Q19_C_DESC"]}
                                    label={DESC}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <>
                                      <Input.TextArea
                                        disabled={disabled}
                                        onBlur={() =>
                                          handleFieldChange(
                                            "STUDENT_PT2_Q19",
                                            JSON.stringify(
                                              form.getFieldValue(
                                                "STUDENT_PT2_Q19"
                                              )
                                            )
                                          )
                                        }
                                        onChange={(e) => {
                                          form.setFieldValue(
                                            [
                                              "STUDENT_PT2_Q19",
                                              name,
                                              "STUDENT_PT2_Q19_C_DESC",
                                            ],
                                            e.target.value
                                          );
                                        }}
                                        maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                                        style={{ paddingBottom: 20 }}
                                      />
                                    </>
                                  </Form.Item>
                                  <LengthCounter
                                    form={form}
                                    fieldName={[
                                      "STUDENT_PT2_Q19",
                                      name.toString(),
                                      "STUDENT_PT2_Q19_C_DESC",
                                    ]}
                                  />
                                </>
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={24}
                              lg={24}
                              xl={24}
                            >
                              <Form.Item
                                {...restField}
                                name={[name, "STUDENT_PT2_Q19_D"]}
                                label={STUDENT_PT2_Q19_D}
                                rules={[
                                  {
                                    required: true,
                                    message: REQUIRED,
                                  },
                                ]}
                              >
                                <Radio.Group
                                  disabled={disabled}
                                  onChange={(e) => {
                                    if (e.target.value === "NO") {
                                      form.setFieldValue(
                                        [
                                          "STUDENT_PT2_Q19",
                                          name,
                                          "STUDENT_PT2_Q19_D_DESC",
                                        ],
                                        ""
                                      );
                                    }
                                    handleFieldChange(
                                      "STUDENT_PT2_Q19",
                                      JSON.stringify(
                                        form.getFieldValue("STUDENT_PT2_Q19")
                                      )
                                    );
                                  }}
                                >
                                  <Radio value='YES'>{YES}</Radio>
                                  <Radio value='NO'>{NO}</Radio>
                                </Radio.Group>
                              </Form.Item>
                              {form.getFieldValue([
                                "STUDENT_PT2_Q19",
                                name,
                                "STUDENT_PT2_Q19_D",
                              ]) === eYES_OR_NO.YES && (
                                <>
                                  <Form.Item
                                    name={[name, "STUDENT_PT2_Q19_D_DESC"]}
                                    label={DESC}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <>
                                      <Input.TextArea
                                        disabled={disabled}
                                        onBlur={() =>
                                          handleFieldChange(
                                            "STUDENT_PT2_Q19",
                                            JSON.stringify(
                                              form.getFieldValue(
                                                "STUDENT_PT2_Q19"
                                              )
                                            )
                                          )
                                        }
                                        onChange={(e) => {
                                          form.setFieldValue(
                                            [
                                              "STUDENT_PT2_Q19",
                                              name,
                                              "STUDENT_PT2_Q19_D_DESC",
                                            ],
                                            e.target.value
                                          );
                                        }}
                                        maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                                        style={{ paddingBottom: 20 }}
                                      />
                                    </>
                                  </Form.Item>
                                  <LengthCounter
                                    form={form}
                                    fieldName={[
                                      "STUDENT_PT2_Q19",
                                      name.toString(),
                                      "STUDENT_PT2_Q19_D_DESC",
                                    ]}
                                  />
                                </>
                              )}
                            </Col>
                          </Row>

                          {form.getFieldValue("STUDENT_PT2_Q19").length - 1 >
                            index && <div className='divider'></div>}
                        </Space>
                      ))}
                    </>
                  )}
                </Form.List>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* GURU AFFIDAVIT TITLE */}
        <div
          id='st_form2_guru_affidavit'
          className='affidavitSection'
        >
          <Row style={{ marginBottom: "5px" }}>
            <Col>
              <Typography.Text>
                {Text({
                  tid: "GURU_AFFIDAVIT_TITLE",
                  def: "Affidavit",
                })}
              </Typography.Text>
            </Col>
          </Row>
          {/* GURU AFFIDAVIT INTRO */}
          <Row className='affidavitRow'>
            <Col xs={24}>
              <Typography.Text type='secondary'>
                {Text({
                  tid: "GURU_AFFIDAVIT_INTRO_11",
                  def: "GURU_AFFIDAVIT_INTRO_11",
                })}
              </Typography.Text>
              <Form.Item
                name='STUDENT_PT2_Q20'
                style={{ maxWidth: "200px" }}
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
                className='affidavitRowInput'
              >
                <Input
                  disabled={disabled}
                  onBlur={(e) =>
                    handleFieldChange("STUDENT_PT2_Q20", e.target.value)
                  }
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
              <Typography.Text type='secondary'>
                {Text({
                  tid: "GURU_AFFIDAVIT_INTRO_12",
                  def: "GURU_AFFIDAVIT_INTRO_12",
                })}
              </Typography.Text>
              <Form.Item
                name='STUDENT_PT2_Q21'
                style={{ maxWidth: "200px" }}
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
                className='affidavitRowInput'
              >
                <Input
                  disabled={disabled}
                  onBlur={(e) =>
                    handleFieldChange("STUDENT_PT2_Q21", e.target.value)
                  }
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
              <Typography.Text type='secondary'>
                {Text({
                  tid: "GURU_AFFIDAVIT_INTRO_13",
                  def: "GURU_AFFIDAVIT_INTRO_13",
                })}
              </Typography.Text>
            </Col>
          </Row>
          {/* GURU AFFIDAVIT DESCRIPTION */}
          <Row>
            <Col>
              <ul>
                <li>
                  <Typography.Text type='secondary'>
                    {Text({
                      tid: "GURU_AFFIDAVIT_CLAUSES_1",
                      def: "GURU_AFFIDAVIT_CLAUSES_1",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text type='secondary'>
                    {Text({
                      tid: "GURU_AFFIDAVIT_CLAUSES_2",
                      def: "GURU_AFFIDAVIT_CLAUSES_2",
                    })}
                  </Typography.Text>
                </li>
              </ul>
              <div>
                <Typography.Text type='secondary'>
                  {Text({
                    tid: "GURU_AFFIDAVIT_VERIFICATION",
                    def: "GURU_AFFIDAVIT_VERIFICATION",
                  })}
                </Typography.Text>
                <Typography.Text type='secondary'>
                  {Text({
                    tid: "GURU_AFFIDAVIT_ACCEPTANCE",
                    def: "GURU_AFFIDAVIT_ACCEPTANCE",
                  })}
                </Typography.Text>
              </div>
            </Col>
          </Row>

          {/* NAME */}
          <Row className='QuestionsSubSection affidavitQuestionFirst'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({ tid: "GURU_FULL_NAME", def: "GURU_FULL_NAME" })}
                  </span>
                  <Form.Item
                    name='STUDENT_PT2_Q23'
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={disabled}
                      onBlur={(e) =>
                        handleFieldChange("STUDENT_PT2_Q23", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='STUDENT_PT2_Q23'
                  label={Text({ tid: "GURU_FULL_NAME", def: "GURU_FULL_NAME" })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("STUDENT_PT2_Q23", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          {/* LOCATION */}
          <Row className='QuestionsSubSection'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({ tid: "GURU_LOCATION", def: "GURU_LOCATION" })}
                  </span>
                  <Form.Item
                    name='STUDENT_PT2_Q24'
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={disabled}
                      onBlur={(e) =>
                        handleFieldChange("STUDENT_PT2_Q24", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='STUDENT_PT2_Q24'
                  label={Text({ tid: "GURU_LOCATION", def: "GURU_LOCATION" })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("STUDENT_PT2_Q24", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          {/* DATE */}
          <Row className='QuestionsSubSection'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({ tid: "GURU_DATE", def: "GURU_DATE" })}
                  </span>
                  <Form.Item
                    name='STUDENT_PT2_Q25'
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={disabled}
                      type={applyPdfStyles ? undefined : "date"}
                      max={disableFutureDates_on_input_date_max()}
                      onChange={(e) =>
                        handleFieldChange("STUDENT_PT2_Q25", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='STUDENT_PT2_Q25'
                  label={Text({ tid: "GURU_DATE", def: "GURU_DATE" })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={disabled}
                    type={applyPdfStyles ? undefined : "date"}
                    max={disableFutureDates_on_input_date_max()}
                    onChange={(e) =>
                      handleFieldChange("STUDENT_PT2_Q25", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          {applyPdfStyles ? (
            <Row className='QuestionsSubSection'>
              <Col
                xs={24}
                lg={12}
                xl={8}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "SIGNATURE_OF_VEDA_TEACHER",
                      def: "Signature of Veda Teacher",
                    })}
                  </span>
                  <Form.Item style={{ marginBottom: 0, flex: 1 }}>
                    <Input id={applyPdfStyles ? "affidavit_input" : ""} />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          ) : null}
        </div>
        <div className='affidavitSection'>
          {!disabled && (
            <Row className='mb-15 QuestionsSubSection'>
              <Button
                type='default'
                onClick={() =>
                  handleGeneratePDF(
                    "st_form2_guru_affidavit",
                    "student_form2_guru_affidavit"
                  )
                }
                className='downloadAffidavitButton'
              >
                {Text({
                  tid: "DOWNLOAD_AFFIDAVIT",
                  def: "Download affidavit",
                })}
              </Button>
            </Row>
          )}

          {/* GURU AFFIDAVIT SIGNATURE */}
          <Row className=' QuestionsSubSection'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='STUDENT_PT2_Q22'
                label={Text({
                  tid: "UPLOAD_AFFIDAVIT",
                  def: "UPLOAD affidavit",
                })}
                rules={[
                  {
                    required:
                      signatureId ||
                      (documentsData?.length &&
                        documentsData.find(
                          (doc: any) => doc.labelName === "STUDENT_PT2_Q22"
                        ))
                        ? false
                        : true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input
                  disabled={disabled}
                  type='file'
                  // onChange={(e) => {
                  //   if (e.target.files && e.target.files[0]) {
                  //     uploadDocument(
                  //       e.target.files[0],
                  //       eDocType.OTHER,
                  //       "STUDENT_PT2_Q22"
                  //     );
                  //   }
                  // }}
                  accept='.jpg,.jpeg,.png,.pdf'
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (!validateFile(file as File).valid) {
                      onShowToast({
                        type: ToastType.error,
                        title: <CloseOutlined />,
                        position: ToastOpen.leftBottom,
                        content: validateFile(file as File).error,
                      });
                      e.target.value = "";
                      form.resetFields(["STUDENT_PT2_Q22"]);
                    } else if (file) {
                      uploadDocument(file, eDocType.OTHER, "STUDENT_PT2_Q22");
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              {signatureId ? (
                <div className='previewLink'>
                  <span>
                    {Text({
                      tid: "ATTACHED_DOCUMENT",
                      def: "Attached Document",
                    })}
                    :
                  </span>
                  <a
                    href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${signatureId}`}
                    target='_blank'
                    rel='noreferrer'
                    className='primary-link'
                  >
                    {PREVIEW}
                  </a>
                </div>
              ) : (
                documentsData &&
                documentsData.length > 0 &&
                documentsData
                  .filter((doc: any) => doc.labelName === "STUDENT_PT2_Q22")
                  .map((doc: any) => (
                    <div className='previewLink'>
                      <span>
                        {Text({
                          tid: "ATTACHED_DOCUMENT",
                          def: "Attached Document",
                        })}
                        :
                      </span>
                      <a
                        href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${doc.docPath}`}
                        target='_blank'
                        rel='noreferrer'
                        className='primary-link'
                      >
                        {doc.docName}
                      </a>
                    </div>
                  ))
              )}
            </Col>
          </Row>
        </div>

        <Row
          style={
            disabled === true
              ? { marginTop: "var(--bs-item-negative-margin-30)" }
              : undefined
          }
        >
          {disabled === false && (
            <Button
              block
              type='primary'
              htmlType='submit'
              disabled={isLoading || disabled || isUploading}
              className='formSubmitButton'
            >
              {Text({ tid: "SUBMIT", def: "SUBMIT" })}
            </Button>
          )}
        </Row>
      </Form>
    </div>
  );
};

export default StudentPartTwo;
